module.exports = __webpack_public_path__ + "5e0d26d6ff9ff0051204f9134b965065.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/gauge-blue.png
// module id = 617
// module chunks = 0